<template>
  <div>
    <section id="sectionId1" class="d-flex body-content pt-0">
      <div class="container-fluid">
        <div class="analytic-wrapper">
          <div class="row">
            <!--right area start-->
            <div class="col p-0 white-bg">
              <div class="analytic-right-wrap">
                <!-- Event Checklist start-->
                <div
                  id="overview_tab"
                  class="cusom-wizard-wrap overview-steaper d-none"
                >
                  <div
                    class="
                      analytic-right-top
                      d-flex
                      justify-content-between
                      align-items-center
                      border-bottom
                      px-6
                      py-3
                    "
                  >
                    <h1>Event Checklist</h1>
                    <div class="final-button" v-if="showHideCheckList">
                      <v-btn
                        color="#1a73e8"
                        large
                        outlined
                        class="cancel-standard"
                        @click="
                          showHideCheckList = false;
                          setCookieCheckList('close');
                        "
                        width="195px"
                      >
                        <v-icon color="#1a73e8" size="20px" class="mr-2"
                          >mdi-minus-thick</v-icon
                        >
                        Hide Checklist
                      </v-btn>
                    </div>
                    <div class="final-button" v-else>
                      <v-btn
                        color="#1a73e8"
                        large
                        outlined
                        class="cancel-standard"
                        @click="
                          showHideCheckList = true;
                          setCookieCheckList('open');
                        "
                        width="195px"
                      >
                        <v-icon color="#1a73e8" size="20px" class="mr-2"
                          >mdi-eye-outline</v-icon
                        >
                        Show Checklist
                      </v-btn>
                    </div>
                  </div>

                  <v-stepper v-model="e6" vertical v-if="showHideCheckList">
                    <div class="d-flex justify-content-start align-items-start" style="height: 100%;">
                      <div
                        class="
                          d-flex
                          justify-content-start
                          align-items-start
                          flex-column
                          stepper-wrap
                          border-right
                        "
                        style="height: 100%;"
                      >
                        <v-stepper-step
                          :complete="e6 > 1"
                          step="1"
                          color="#000"
                          @click="e6 = 1"
                        >
                          <p class="stepper-text mb-0"><b>Setup Event</b></p>
                        </v-stepper-step>
                        <v-stepper-step
                          :complete="e6 > 2"
                          step="2"
                          color="#000"
                          @click="e6 = 2"
                        >
                          <p class="stepper-text mb-0">
                            <b>Add Attendees</b>
                          </p>
                        </v-stepper-step>
                        <v-stepper-step
                          :complete="e6 > 3"
                          step="3"
                          color="#000"
                          @click="e6 = 3"
                        >
                          <p class="stepper-text mb-0">
                            <b>Add Speakers</b>
                          </p>
                        </v-stepper-step>
                        <v-stepper-step
                          :complete="e6 > 4"
                          step="4"
                          color="#000"
                          @click="e6 = 4"
                        >
                          <p class="stepper-text mb-0">
                            <b>Add Sessions</b>
                          </p>
                        </v-stepper-step>

                        <v-stepper-step
                          :complete="e6 > 5"
                          step="5"
                          color="#000"
                          @click="e6 = 5"
                        >
                          <p class="stepper-text mb-0 text-nowrap">
                            <b>Preview & Publish</b>
                          </p>
                        </v-stepper-step>
                      </div>
                      <v-stepper-items>
                        <v-stepper-content
                          v-if="e6 == 1"
                          step="1"
                          class="py-0 m-0 full-width px-3"
                        >
                          <div class="analytic-st-one">
                            <div class="card full-width">
                              <!-- <div class="card-header border" id="headingOne">
                                <h5 class="mb-0">
                                  <button
                                    class="btn btn-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#collapseOne"
                                    aria-expanded="true"
                                    aria-controls="collapseOne"
                                  >
                                    Setup Event
                                  </button>
                                </h5>
                              </div> -->
                              <div
                                id="collapseOne"
                                class="collapse show"
                                aria-labelledby="headingOne"
                                data-parent="#accordion"
                              >
                                <div class="card-body px-0">
                                  <div class="d-flex setup-body-c align-items-center">
                                    <div class="d-flex full-width justify-content-start align-items-start">
                                      <label>
                                        <v-icon color="#585963" size="20px"
                                          >mdi-calendar-blank-outline</v-icon
                                        >
                                      </label>

                                      <div class="m-text cursor-pointer" @click="openBasicSetup()">
                                        <p class="black--text mb-0">
                                          Check your event details
                                        </p>
                                        <p class="text-muted mb-0">
                                          Add the basics - date,time and areas for
                                          your event
                                        </p>
                                      </div>
                                    </div>

                                    <label
                                      class="text-right cursor-pointer"
                                      @click="openBasicSetup()"
                                    >
                                      <v-icon color="#585963" size="35px"
                                        >mdi-chevron-right</v-icon
                                      >
                                    </label>
                                  </div>
                                  <div class="d-flex setup-body-c align-items-center">
                                    <div class="d-flex full-width justify-content-start align-items-start">
                                      <label>
                                        <v-icon color="#585963" size="20px"
                                          >mdi-calendar-range-outline</v-icon
                                        >
                                      </label>
                                      <div class="m-text cursor-pointer" @click="openRegistrationTypeDialog()">
                                        <p class="black--text mb-0">
                                          Create registration types
                                        </p>
                                        <p class="text-muted mb-0">
                                          set up registration types for your event
                                        </p>
                                      </div>
                                    </div>
                                    <label
                                      class="text-right cursor-pointer"
                                      @click="openRegistrationTypeDialog()"
                                    >
                                      <v-icon color="#585963" size="35px"
                                        >mdi-chevron-right</v-icon
                                      >
                                    </label>
                                  </div>
                                  <div class="d-flex setup-body-c align-items-center">
                                    <div class="d-flex full-width justify-content-start align-items-start">
                                      <label>
                                        <v-icon color="#585963" size="20px"
                                          >mdi-monitor</v-icon
                                        >
                                      </label>
                                      <div class="m-text cursor-pointer"  @click="openRegistrationPage()">
                                        <p class="black--text mb-0">
                                          Create an event landing page
                                        </p>
                                        <p class="text-muted mb-0">
                                          Design a custom landing page to match
                                          your brand
                                        </p>
                                      </div>
                                    </div>
                                    <label
                                      class="text-right cursor-pointer"
                                      @click="openRegistrationPage()"
                                    >
                                      <v-icon color="#585963" size="35px"
                                        >mdi-chevron-right</v-icon
                                      >
                                    </label>
                                  </div>
                                  <v-btn
                                    class="ml-10 mt-4"
                                    outlined
                                    color="indigo"
                                    @click="e6 = 2"
                                  >
                                    Skip Step
                                  </v-btn>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-stepper-content>

                        <!-- <v-stepper-content
                          v-if="e6 == 2"
                          step="2"
                          class="py-0 m-0 full-width px-3"
                        >
                          <div class="card full-width">
                            <div class="card-header border" id="headingtwo">
                              <h5 class="mb-0">
                                <button
                                  class="btn btn-link"
                                  data-toggle="collapse"
                                  data-target="#collapsetwo"
                                  aria-expanded="false"
                                  aria-controls="collapsetwo"
                                >
                                  Build Venue
                                </button>
                              </h5>
                            </div>
                            <div
                              id="collapsetwo"
                              class="collapse show"
                              aria-labelledby="headingtwo"
                              data-parent="#accordion"
                            >
                              <div class="card-body px-0">
                                <div class="d-flex setup-body-c">
                                  <label>
                                    <v-icon color="#585963" size="20px"
                                      >mdi-home-outline</v-icon
                                    >
                                  </label>
                                  <div class="m-text">
                                    <p class="black--text mb-0">
                                      Setup reception area
                                    </p>
                                    <p class="text-muted mb-0">
                                      Add a welcome event for your event
                                    </p>
                                  </div>
                                  <label class="text-right">
                                    <v-icon color="#585963" size="20px"
                                      >mdi-chevron-right</v-icon
                                    >
                                  </label>
                                </div>
                                <div class="d-flex setup-body-c">
                                  <label>
                                    <v-icon color="#585963" size="20px"
                                      >mdi-account-group-outline</v-icon
                                    >
                                  </label>
                                  <div class="m-text">
                                    <p class="black--text mb-0">
                                      Create Round Table
                                    </p>
                                    <p class="text-muted mb-0">
                                      set up interactive roundtables,interview
                                      and workshops
                                    </p>
                                  </div>
                                  <label class="text-right">
                                    <v-icon color="#585963" size="20px"
                                      >mdi-chevron-right</v-icon
                                    >
                                  </label>
                                </div>
                                <div class="d-flex setup-body-c">
                                  <label>
                                    <v-icon color="#585963" size="20px"
                                      >mdi-video-outline</v-icon
                                    >
                                  </label>
                                  <div class="m-text">
                                    <p class="black--text mb-0">
                                      Create sessions
                                    </p>
                                    <p class="text-muted mb-0">
                                      Create a main stage for hosting your event
                                    </p>
                                  </div>
                                  <label class="text-right">
                                    <v-icon color="#585963" size="20px"
                                      >mdi-chevron-right</v-icon
                                    >
                                  </label>
                                </div>
                                <v-btn
                                  class="ml-10 mt-4"
                                  outlined
                                  color="indigo"
                                  @click="e6 = 3"
                                >
                                  Skip Step
                                </v-btn>
                              </div>
                            </div>
                          </div>

                        </v-stepper-content> -->
                        <v-stepper-content
                          v-if="e6 == 2"
                          step="2"
                          class="py-0 m-0 full-width px-3"
                        >
                          <!----step 3 start-->
                          <div class="card">
                            <!-- <div class="card-header border" id="headingthree">
                              <h5 class="mb-0">
                                <button
                                  class="btn btn-link"
                                  data-toggle="collapse"
                                  data-target="#collapsethree"
                                  aria-expanded="false"
                                  aria-controls="collapsethree"
                                >
                                  Add Attendees
                                </button>
                              </h5>
                            </div> -->
                            <div
                              id="collapsethree"
                              class="collapse show center-class"
                              aria-labelledby="headingthree"
                              data-parent="#accordion"
                            >
                              <div class="card-body text-center">
                                <v-icon color="#007bff" size="25px"
                                  >mdi-account-group</v-icon
                                >
                                <p class="black--text mb-0">
                                  Create attendee profiles
                                </p>
                                <p class="text-muted mb-4">
                                  Add attendees and invite them to join the
                                  event
                                </p>
                                <v-btn
                                  color="#1a73e8"
                                  class="white--text"
                                  @click="openCreateAttendee()"
                                >
                                  Create
                                </v-btn>
                                <p class="text-right mt-4">
                                  <v-btn
                                    class="ml-10 mt-4"
                                    outlined
                                    color="#1a73e8"
                                    @click="e6 = 3"
                                  >
                                    Skip Step
                                  </v-btn>
                                </p>
                              </div>
                            </div>
                          </div>
                          <!----step 3 end-->
                        </v-stepper-content>
                        <v-stepper-content
                          v-if="e6 == 3"
                          step="3"
                          class="py-0 m-0 full-width px-3"
                        >
                          <!----step 3 start-->
                          <div class="card">
                            <!-- <div class="card-header border" id="headingthree">
                              <h5 class="mb-0">
                                <button
                                  class="btn btn-link"
                                  data-toggle="collapse"
                                  data-target="#collapsethree"
                                  aria-expanded="false"
                                  aria-controls="collapsethree"
                                >
                                  Add Speakers
                                </button>
                              </h5>
                            </div> -->
                            <div
                              id="collapsethree"
                              class="collapse show center-class"
                              aria-labelledby="headingthree"
                              data-parent="#accordion"
                            >
                              <div class="card-body text-center">
                                <v-icon color="#007bff" size="25px"
                                  >mdi-account-group</v-icon
                                >
                                <p class="black--text mb-0">
                                  Create speaker profiles
                                </p>
                                <p class="text-muted mb-4">
                                  Add speakers and invite them to join the event
                                </p>
                                <v-btn
                                  color="#1a73e8"
                                  class="white--text"
                                  @click="openCreateSpeaker()"
                                >
                                  Create
                                </v-btn>
                                <p class="text-right mt-4">
                                  <v-btn
                                    class="ml-10 mt-4"
                                    outlined
                                    color="#1a73e8"
                                    @click="e6 = 4"
                                  >
                                    Skip Step
                                  </v-btn>
                                </p>
                              </div>
                            </div>
                          </div>
                          <!----step 3 end-->
                        </v-stepper-content>
                        <v-stepper-content
                          v-if="e6 == 4"
                          step="4"
                          class="py-0 m-0 full-width px-3"
                        >
                          <!----step 3 start-->
                          <div class="card">
                            <!-- <div class="card-header border" id="headingthree">
                              <h5 class="mb-0">
                                <button
                                  class="btn btn-link"
                                  data-toggle="collapse"
                                  data-target="#collapsethree"
                                  aria-expanded="false"
                                  aria-controls="collapsethree"
                                >
                                  Add Speakers
                                </button>
                              </h5>
                            </div> -->

                            <div
                              class="d-inline-block"
                              style="min-width: 120px"
                            >
                              <v-chip
                                class="ma-2 disable-badge d-inline-flex"
                                color="#1a73e8"
                                label
                                text-color="white"
                              >
                                <v-icon bottom class="mr-2"> mdi-label </v-icon>
                                Coming Soon
                              </v-chip>
                            </div>

                            <div
                              id="collapsethree"
                              class="collapse show center-class disable-step"
                              aria-labelledby="headingthree"
                              data-parent="#accordion"
                            >
                              <div class="card-body text-center">
                                <v-icon color="#007bff" size="25px"
                                  >mdi-account-group</v-icon
                                >
                                <p class="black--text mb-0">Create sessions</p>
                                <p class="text-muted mb-4">
                                  Add sessions and invite speakers to join in it
                                </p>
                                <v-btn color="#1a73e8" class="white--text">
                                  Create
                                </v-btn>
                                <p class="text-right mt-4">
                                  <v-btn
                                    class="ml-10 mt-4"
                                    outlined
                                    color="#1a73e8"
                                    @click="e6 = 5"
                                  >
                                    Skip Step
                                  </v-btn>
                                </p>
                              </div>
                            </div>
                          </div>
                          <!----step 3 end-->
                        </v-stepper-content>
                        <v-stepper-content
                          v-if="e6 == 5"
                          step="5"
                          class="py-0 m-0 full-width px-3"
                        >
                          <!----step 4 -->

                          <div class="card full-width">
                            <!-- <div class="card-header border" id="headingfour">
                              <h5 class="mb-0">
                                <button
                                  class="btn btn-link"
                                  data-toggle="collapse"
                                  data-target="#collapsefour"
                                  aria-expanded="false"
                                  aria-controls="collapsefour"
                                >
                                  Preview & Publish
                                </button>
                              </h5>
                            </div> -->
                            <div
                              id="collapsefour"
                              class="collapse show"
                              aria-labelledby="headingfour"
                              data-parent="#accordion"
                            >
                              <div class="card-body px-0">
                                <div class="d-flex setup-body-c">
                                  <label>
                                    <v-icon color="#585963" size="20px"
                                      >mdi-calendar-text</v-icon
                                    >
                                  </label>
                                  <div class="m-text cursor-pointer"  @click="openRegPreviewMode()">
                                    <p class="black--text mb-0">
                                      Preview event landing page
                                    </p>
                                    <p class="text-muted mb-0">
                                      Take a peek at your event's registration
                                      page
                                    </p>
                                  </div>
                                  <label
                                    class="text-right cursor-pointer"
                                    @click="openRegPreviewMode()"
                                  >
                                    <v-icon color="#585963" size="20px"
                                      >mdi-chevron-right</v-icon
                                    >
                                  </label>
                                </div>
                                <div class="d-flex setup-body-c">
                                  <label>
                                    <v-icon color="#585963" size="20px"
                                      >mdi-publish</v-icon
                                    >
                                  </label>
                                  <div class="m-text">
                                    <p class="black--text mb-0">
                                      Publish your event
                                    </p>
                                    <p class="text-muted mb-0">
                                      If everything looks good you can publish
                                      your event
                                    </p>
                                  </div>
                                  <label class="text-right">
                                    <v-icon color="#585963" size="20px"
                                      >mdi-chevron-right</v-icon
                                    >
                                  </label>
                                </div>

                                <v-btn
                                  color="#1a73e8"
                                  class="white--text ml-10"
                                  @click="eventPublishDialog()"
                                >
                                  publish
                                </v-btn>
                              </div>
                            </div>
                          </div>
                          <!----step 4 end-->
                        </v-stepper-content>
                      </v-stepper-items>
                      <!------>
                      <!-- left start -->
                      
                      <div class="card border mr-3 overview-right mt-16">
                        <div class="card-body">
                          <p class="black--text mb-2">Shareable Links</p>
                          <p class="text-muted mb-2">
                            Link for attendees and speakers to access your
                            event, or stream over RTMP.
                          </p>

                          <a
                            href="#"
                            class="link-view"
                            @click="openChecklistDialog()"
                          >
                            <v-icon color="#007bff" size="20px" class="mr-1"
                              >mdi-link-variant</v-icon
                            >
                            View Links
                          </a>
                        </div>
                      </div>
                      <!-- left end -->
                    </div>
                  </v-stepper>
                </div>
                <!------>
                <!-- Event Checklist end-->
                <!-- Analytics Dashboard section start -->
                <section class="page-bottom-section mt-4">
                  <div
                    class="
                      analytic-right-top
                      d-flex
                      justify-content-between
                      align-items-center
                      border-bottom
                      px-6
                      py-3
                    "
                  >
                    <h1>Analytics Dashboard 

                      
                              
                            
                    </h1>

                    <div class="final-button" v-if="showHideAnalytics">
                      <v-btn
                        color="#1a73e8"
                        large
                        outlined
                        class="cancel-standard"
                        @click="
                          showHideAnalytics = false;
                          setCookieAnalytics('close');
                        "
                        width="195px"
                      >
                        <v-icon color="#1a73e8" size="20px" class="mr-2"
                          >mdi-minus-thick</v-icon
                        >
                        Hide Analytics
                      </v-btn>
                    </div>

                    <div class="final-button" v-else>
                      <v-btn
                        color="#1a73e8"
                        large
                        outlined
                        class="cancel-standard"
                        @click="
                          showHideAnalytics = true;
                          setCookieAnalytics('open');
                        "
                        width="195px"
                      >
                        <v-icon color="#1a73e8" size="20px" class="mr-2"
                          >mdi-eye-outline</v-icon
                        >
                        Show Analytics
                      </v-btn>
                    </div>
                  </div>
                  <div class="d-flex row m-0" v-if="showHideAnalytics">
                    <!-- left side start -->
                    <!--left area start-->
                    <div class="col analytic-left-wrap">
                      <ul>
                        <li>
                          <a href="#">Analytics Dashboard</a>
                        </li>
                        <li>
                          <a href="#">Live Visitors</a>
                        </li>
                        <li>
                          <a href="#">User Login</a>
                        </li>
                        <li>
                          <a href="#">Engagemnt</a>
                        </li>
                        <li>
                          <a href="#">User Journey</a>
                        </li>
                        <li>
                          <a href="#">Registration</a>
                        </li>
                      </ul>
                    </div>

                    <!-- left side end -->
                    <!-- right side start -->
                    <div class="col p-0 bg-light">
                      <!-- comming soon -->
                      <div class="coming-soon-wrap text-center">
 <img src="../assets/Images/coming-soon.png" alt="coming soon">
 <h3 class="my-3">Coming Soon...</h3>
                      </div>
                     
                      <!--empty-->
                      <div class="empty_event_wrap text-center py-4 d-none">
                        <span class="sm-circle mx-auto">
                          <v-icon color="#007bff" size="30px">mdi-poll</v-icon>
                        </span>
                        <h5 class="mt-2">
                          Your event Analytics will appear here after you
                          <br />publish the event
                        </h5>


                      </div>

                      <!--empty-->
                      <!--dashboard start--->
                      <div class="dashboard-wrapper bg-light d-none">
                        <!--right body area atart-->
                        <div class="px-5">
                          <div class="row my-0 mt-3">
                            <div class="col-md-6">
                              <div class="card py-4 border-none">
                                <div class="px-4">
                                  <span class="sm-circle">
                                    <v-icon color="#007bff" size="30px"
                                      >mdi-account-group-outline</v-icon
                                    >
                                  </span>
                                  <h2 class="mt-3 mb-1">
                                    <strong>529</strong>
                                  </h2>
                                  <p>Engagemnt in last 7 days</p>
                                </div>
                                <!----->
                                <div id="chart">
                                  <apexchart
                                    type="area"
                                    height="350"
                                  ></apexchart>
                                </div>
                                <!----->
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="card py-4 border-none">
                                <div class="px-4">
                                  <h2 class="mt-3 mb-1">Session: 5</h2>
                                </div>
                                <!----->
                                <div id="chart">
                                  <apexchart
                                    type="area"
                                    height="350"
                                  ></apexchart>
                                </div>
                                <!----->
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="card py-4 border-none">
                                <div class="px-4">
                                  <h2 class="mt-3 mb-1">Round Tables: 0</h2>
                                </div>
                                <!----->
                                <div id="chart">
                                  <apexchart
                                    type="area"
                                    height="350"
                                  ></apexchart>
                                </div>
                                <!----->
                              </div>
                            </div>
                            <!----registration--->
                            <div class="col-md-6">
                              <div class="card p-4 border-none">
                                <div class="">
                                  <h2 class="mt-3 mb-1">Registrations</h2>
                                  <h2 class="mt-3 mb-1"><strong>12</strong></h2>
                                  <p>Registrations</p>
                                  <br />
                                  <p><strong>Free 12</strong></p>
                                  <br />
                                  <v-btn
                                    large
                                    dark
                                    color="#1973e7"
                                    width="152px"
                                    >View Details</v-btn
                                  >
                                  <hr />
                                </div>
                                <!----->
                                <div id="chart">
                                  <apexchart
                                    type="area"
                                    height="350"
                                  ></apexchart>
                                </div>
                                <!----->
                              </div>
                            </div>
                            <!----Overview--->
                            <div class="col-md-6">
                              <div class="card p-4 border-none">
                                <div class="">
                                  <h2 class="mt-3 mb-1">Overview</h2>
                                </div>
                                <!----->
                                <div id="chart">
                                  <apexchart
                                    type="area"
                                    height="350"
                                  ></apexchart>
                                </div>
                                <!----->
                              </div>
                            </div>
                            <!----Overview--->
                            <div class="col-md-12">
                              <div class="card p-4 border-none">
                                <div class="">
                                  <h2 class="mt-3 mb-1">Engagement- 30 days</h2>
                                </div>
                                <!----->
                                <div id="chart">
                                  <apexchart
                                    type="area"
                                    height="350"
                                  ></apexchart>
                                </div>
                                <!----->
                              </div>
                            </div>
                            <!----Overview--->
                            <div class="col-md-12">
                              <div class="card p-4 border-none">
                                <div class="">
                                  <h2 class="mt-3 mb-1">
                                    Login Summary- 30 days
                                  </h2>
                                </div>
                                <!----->
                                <div id="chart">
                                  <apexchart
                                    type="area"
                                    height="350"
                                  ></apexchart>
                                </div>
                                <!----->
                                <v-btn large dark color="#1973e7" width="152px"
                                  >View Details</v-btn
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--dashboard end--->
                      <!--Registration start--->
                      <div class="registration-wrapper" style="display: none">
                        <div class="analytic-right-top border-bottom px-6 py-3">
                          <h1>Registration</h1>
                        </div>
                        <div class="px-5"></div>

                        <!--Registration body start--->
                        <div class="px-5">
                          <div class="row reg-inner-box-wrap my-0 mt-3">
                            <div class="col-5">
                              <div class="total-c box_reg">
                                <h5>Total Collected</h5>
                                <h2>&#x24; 84000</h2>
                              </div>
                            </div>
                            <div class="col">
                              <div class="box_reg">
                                <h5>Student</h5>
                                <h2>&#x24; 84000</h2>
                              </div>
                            </div>
                            <div class="col">
                              <div class="box_reg">
                                <h5>Regular</h5>
                                <h2>&#x24; 84000</h2>
                              </div>
                            </div>
                            <div class="col">
                              <div class="box_reg">
                                <h5>Vip</h5>
                                <h2>&#x24; 84000</h2>
                              </div>
                            </div>
                          </div>
                          <div class="row reg-inner-box-wrap my-0 mt-3">
                            <!-----50 width row -->
                            <div class="col-6">
                              <div
                                class="
                                  box_reg
                                  d-flex
                                  align-items-center
                                  justify-content-between
                                  p-4
                                "
                              >
                                <h5>
                                  <img
                                    src="../assets/Images/icons/payment-com.png"
                                    class="mr-3"
                                  />Payment Complete
                                </h5>
                                <h2>115</h2>
                              </div>
                            </div>
                            <div class="col-6">
                              <div
                                class="
                                  box_reg
                                  d-flex
                                  align-items-center
                                  justify-content-between
                                  p-4
                                "
                              >
                                <h5>
                                  <img
                                    src="../assets/Images/icons/payment-pending.png"
                                    class="mr-3"
                                  />Payment Pending
                                </h5>
                                <h2>115</h2>
                              </div>
                            </div>
                            <!-----50 width row -->
                          </div>
                          <h2 class="py-3">Registrant</h2>
                          <div class="table-responsive registrant-table">
                            <table class="table table-condensed border">
                              <thead>
                                <tr>
                                  <th>
                                    <!-- <input type="checkbox"> -->
                                    <v-checkbox
                                      color="#1a74e8"
                                      value="red"
                                      hide-details
                                    ></v-checkbox>
                                  </th>
                                  <th>ID</th>
                                  <th>Name</th>
                                  <th>Email</th>
                                  <th>Amount</th>
                                  <th>Transection ID</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      color="#1a74e8"
                                      value="red"
                                      hide-details
                                    ></v-checkbox>
                                  </td>
                                  <td>123456</td>
                                  <td>Jerry Murray</td>
                                  <td>Jerry.murray@gmail.com</td>
                                  <td>&#x24;500</td>
                                  <td>99900154</td>
                                  <td>
                                    <span class="status_c st-com"
                                      >Complete</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      color="#1a74e8"
                                      value="red"
                                      hide-details
                                    ></v-checkbox>
                                  </td>
                                  <td>123456</td>
                                  <td>Jerry Murray</td>
                                  <td>Jerry.murray@gmail.com</td>
                                  <td>&#x24;500</td>
                                  <td>99900154</td>
                                  <td>
                                    <span class="status_c st-pending"
                                      >Pending</span
                                    >
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <!--Registration body end-->
                      </div>
                    </div>
                    <!-- right side end -->
                  </div>
                </section>
                <!-- page bottom section end -->
              </div>
            </div>
            <!--right area end-->
          </div>
        </div>
      </div>
      <v-dialog
        transition="dialog-top-transition"
        max-width="600"
        v-model="checkListDialogOpen"
      >
        <template v-slot:default="dialog">
          <v-card>
            <div class="event-links-wrapper position-relative">
              <div class="close-action">
                <v-btn fab small @click="dialog.value = false"
                  ><v-icon>mdi-close</v-icon></v-btn
                >
              </div>
              <h3>Shareable Links</h3>
              <div class="tabs-wrap mt-8">
                <v-tabs
                  v-model="tab"
                  background-color="transparent"
                  color="#1a73e8"
                  grow
                >
                  <v-tab> Registration </v-tab>
                  <!-- <v-tab> e2m Studio </v-tab> -->
                  <v-tab> RTMP </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <v-card color="basil" flat>
                      <v-card-text>
                        <div class="p-4 common-fields-wrap">
                          <p>
                            Use this link to invite people to join your
                            registration page:
                          </p>
                          <label>Registration link</label>
                          <span id="reglinkCopied">copied!</span>
                          <div class="link-feild-wrap">
                            <input
                              type="text"
                              id="reglink"
                              :value="getPublishLink"
                            />
                            <v-btn @click="copyEventLink"
                              ><v-icon>mdi-content-copy</v-icon></v-btn
                            >
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item v-if="false">
                    <v-card color="basil" flat>
                      <v-card-text>
                        <div class="p-4 common-fields-wrap">
                          <p>
                            Use this link to invite speakers into the backstage:
                          </p>

                          <div class="link-feild-wrap mt-8">
                            <div class="down-arrow-ico">
                              <v-icon color="#333" size="25px">mdi-chevron-down</v-icon>
                            </div>
                            <v-menu offset-y max-height="300">
                              <template v-slot:activator="{ on, attrs }">
                                <div
                                  class="link-drop"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  {{ selectedSpeaker.Name }}
                                </div>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="speaker in speakerList"
                                  :key="speaker"
                                  @click="onSpeakerSelected(speaker)"
                                >
                                  <v-list-item-title
                                    class="position-relative sp-name-btn"
                                  >
                                    <h4>{{ speaker.Name }}</h4>
                                    <p>{{ speaker.Designation }}</p>
                                    <p>{{ speaker.Company }}</p>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </div>
                          <label>e2m studio link</label>
                          <span id="speakerlinkCopied">copied!</span>
                          <div class="link-feild-wrap">
                            <input
                              type="text"
                              id="speakerlink"
                              :value="speakerJoinURL"
                            />
                            <v-btn @click="copySpeakerLink"
                              ><v-icon>mdi-content-copy</v-icon></v-btn
                            >
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card color="basil" flat>
                      <v-card-text>
                        <div class="p-4 common-fields-wrap">
                          <p class="mb-2">
                            If you are using RTMP, use this key and link to
                            stream your broadcast:
                          </p>
                          <div>
                            <div class="position-relative cursor-pointer">
                              <div class="down-arrow-ico">
                                <v-icon color="#333" size="25px">mdi-chevron-down</v-icon>
                              </div>
                              <v-menu offset-y max-height="300">
                                <template v-slot:activator="{ on, attrs }">
                                  <div
                                    class="link-drop"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <p class="m-0">{{ selectedSession.Name }}</p>
                                  </div>
                                </template>
                                <v-list>
                                  <v-list-item
                                    v-for="session in sessionList"
                                    :key="session"
                                    @click="onSessionSelected(session)"
                                  >
                                    <v-list-item-title
                                      class="position-relative sp-name-btn"
                                    >
                                      <h4>{{ session.Name }}</h4>
                                      <p>{{ session.TrackName }}</p>
                                      <p>{{ session.SessionTime }}</p>
                                    </v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </div>
                          </div>
                          <label>Stream key</label>
                          <span id="streamKeyCopied">copied!</span>
                          <div class="link-feild-wrap mb-3">
                            <input
                              type="text"
                              id="streamKey"
                              :value="streamKey"
                            />
                            <v-btn @click="copyStreamKey"
                              ><v-icon>mdi-content-copy</v-icon></v-btn
                            >
                          </div>
                          <label>RTMP URL</label>
                          <span id="RTMPURLCopied">copied!</span>
                          <div class="link-feild-wrap">
                            <input type="text" id="RTMPURL" :value="RTMPURL" />
                            <v-btn @click="copyRTMPURL"
                              ><v-icon>mdi-content-copy</v-icon></v-btn
                            >
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </div>
          </v-card>
        </template>
      </v-dialog>
    </section>
  </div>
  <!----------right attendee detail-------->
</template>
<style scoped>
.disable-step {
  filter: grayscale(100%);
  opacity: 0.4;
}

.v-stepper--vertical {
  padding-bottom: 0 !important;
}

#streamKeyCopied,
#RTMPURLCopied,
#speakerlinkCopied,
#reglinkCopied {
  display: none;
  float: right;
  padding: 5px 12px;
  margin-top: 15px;
  background-color: #ffffff;
  border-radius: 4px;
  color: #2376e5;
  text-align: center;
}
</style>

<script>
import APIs from "@/components/APIInit";
import axios from "axios";
//import Vue from "vue";
//import ApexCharts from 'apexcharts'
// import jQuery from "jquery";
// let $ = jQuery;
import db from "../components/firebaseInit";
import { bus } from "@/main";
import router from "../router";
import common from "@/common";

var vm;
export default {
  // Registration() {
  //   $(".registration-wrapper").show();
  //   $(".dashboard-wrapper").hide();
  // },
  // dashboard() {
  //   $(".registration-wrapper").hide();
  //   $(".dashboard-wrapper").show();
  // },
  // overview() {
  //   $("#overview_tab").show();
  //   $(".registration-wrapper").hide();
  //   $(".dashboard-wrapper").hide();
  // },
  data() {
    return {
      clientId: "",
      eventId: "",
      eventCollectionName: "",
      e6: 1,
      drawer: false,
      currentTabId: 1,
      currentOptionId: 1,
      checkListDialogOpen: false,
      tab: null,
      showHideCheckList: true,
      showHideAnalytics: true,
      speakerJoinURL: "",
      selectedSpeaker: {
        SpeakerId: "",
        Name: "Speaker's Name",
        Company: "",
        Designation: "",
        Email: "",
      },
      speakerList: [],
      selectedSession: {
        SessionId: "",
        Name: "Sesssion Name",
        TrackName: "",
        SessionTime: "",
      },
      sessionList: [],
      streamKey: "",
      RTMPURL: "",
    };
  },
  created() {},
  mounted() {
    vm = this;
    vm.clientId = vm.getClientId();
    vm.eventId = vm.getEventId();
    vm.eventCollectionName = vm.getEventCollectionName();
    vm.getSpeakerList();
    vm.getSessionList();
    var cookiechecklist = vm.getCookie("checkListTab");
    var analyticscookielist = vm.getCookie("checkListAnalyticsTab");

    if (cookiechecklist) {
      vm.showHideCheckList = cookiechecklist == "close" ? false : true;
    }

    if (analyticscookielist) {
      vm.showHideAnalytics = analyticscookielist == "close" ? false : true;
    }
  },
  methods: {
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    setCookieCheckList(val) {
      document.cookie = "checkListTab=" + val;
    },
    setCookieAnalytics(val) {
      document.cookie = "checkListAnalyticsTab=" + val;
    },
    openRegPreviewMode() {
      var eventId = vm.getEventId();
      router.push("/eventv3/" + eventId);
    },
    eventPublishDialog() {
      bus.$emit("changeEventStatusConfirm");
    },
    openRegistrationTypeDialog() {
      var eventId = vm.getEventId();
      router.push("/admin-event/" + eventId + "#type");
    },
    openRegistrationPage() {
      var eventId = vm.getEventId();
      router.push("/admin-event/" + eventId);
    },
    openCreateSpeaker() {
      router.push("/admin-speakers#create");
    },
    openCreateAttendee() {
      router.push("/admin-attendee#create");
    },
    openBasicSetup() {
      bus.$emit("openBasicSetup", true);
    },
    StepClicked(step) {
      debugger;
      alert(step);
      vm.e6 = step;
    },
    getSpeakerList() {
      vm.speakerList = [];
      db.collection(vm.eventCollectionName)
        .doc("SpeakerList")
        .collection("Speakers")
        .where("IsPublished", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            debugger;
            let data = doc.data();
            vm.speakerList.push({
              SpeakerId: data.SpeakerId,
              Name: data.Name,
              Company: data.Company,
              Designation: data.Designation,
              Email: data.Email,
            });
          });
          vm.speakerList.sort(function (a, b) {
            if (a.Name < b.Name) {
              return -1;
            }
            if (a.Name > b.Name) {
              return 1;
            }
            return 0;
          });
          //alert(vm.speakerList.length)
          if (vm.speakerList.length > 0) {
            //alert(vm.speakerList[0].Name)

            //vm.selectedSpeaker = vm.speakerList[0];
            vm.onSpeakerSelected(vm.speakerList[0]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onSpeakerSelected(speaker) {
      console.log(speaker);
      debugger
      vm.speakerJoinURL = "";
      vm.selectedSpeaker = speaker;
      if (speaker.SpeakerId) {
        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + vm.getSessionToken(),
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: vm.clientId,
            eventId: vm.eventId,
          },
          data: {
            userId: speaker.SpeakerId,
          },
        };
        axios
          .post(APIs.GetJoinURL, requestData, {
            headers: headers,
          })
          .then((response) => {
            //vm.ManageMenuUpdating = false;
            if (response && response.data && response.data.status == 0) {
              vm.speakerJoinURL = response.data.joinURL;
            } else {
              //vm.showSnackbar("Menu updated failed!", "error", "top");
            }
          })
          .catch((error) => {
            //vm.ManageMenuUpdating = false;
            debugger;
            //alert("SaveManageMenu Failure");
            console.log("onSpeakerSelected: " + error);
            //vm.showSnackbar("Menu updated failed!", "error", "top");
          });
      }
    },
    getSessionList() {
      vm.sessionList = [];
      db.collection(vm.eventCollectionName)
        .doc("SessionList")
        .collection("Sessions")
        .where("IsPublished", "==", true)
        .orderBy("StartDate", "asc")
        .orderBy("EndDate", "asc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let data = doc.data();
            if (data.StreamingClient == "Zoom") {
              let sessionTime = common.getFormattedDateTime(
                data.StartDate.seconds
              );
              let sessionEndTime = common.getFormattedDateTime(
                data.EndDate.seconds
              );
              sessionTime += " - " + sessionEndTime;
              if (
                sessionTime.substring(0, 8) == sessionEndTime.substring(0, 8)
              ) {
                sessionTime = sessionTime.replaceAll(
                  sessionEndTime.substring(0, 8),
                  ""
                );
              }
              vm.sessionList.push({
                SessionId: data.SessionId,
                Name: data.Name,
                TrackName: data.Track.TrackName,
                SessionTime: sessionTime,
                ZoomRTMPMUX_detail: data.ZoomRTMPMUX_detail,
              });
            }
          });
          if (vm.sessionList.length > 0) {
            vm.selectedSession = vm.sessionList[0];
            vm.onSessionSelected(vm.selectedSession);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onSessionSelected(session) {
      (vm.streamKey = ""), (vm.RTMPURL = "");
      vm.selectedSession = session;
      if (session.SessionId && session.ZoomRTMPMUX_detail) {
        (vm.streamKey =
          session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.streamKey),
          (vm.RTMPURL = session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.url);
      }
    },
    openChecklistDialog() {
      vm.checkListDialogOpen = true;
    },
    copyEventLink() {
      var ct = document.getElementById("reglink");
      ct.select();
      ct.setSelectionRange(0, 99999);
      document.getElementById("reglinkCopied").style.display = "block";
      document.execCommand("copy");
      setTimeout(function () {
        document.getElementById("reglinkCopied").style.display = "none";
      }, 1000);
    },
    copySpeakerLink() {
      var ct = document.getElementById("speakerlink");
      ct.select();
      ct.setSelectionRange(0, 99999);
      document.getElementById("speakerlinkCopied").style.display = "block";
      document.execCommand("copy");
      setTimeout(function () {
        document.getElementById("speakerlinkCopied").style.display = "none";
      }, 1000);
    },
    copyStreamKey() {
      var ct = document.getElementById("streamKey");
      ct.select();
      ct.setSelectionRange(0, 99999);
      document.getElementById("streamKeyCopied").style.display = "block";
      document.execCommand("copy");
      setTimeout(function () {
        document.getElementById("streamKeyCopied").style.display = "none";
      }, 1000);
    },
    copyRTMPURL() {
      var ct = document.getElementById("RTMPURL");
      ct.select();
      ct.setSelectionRange(0, 99999);
      document.getElementById("RTMPURLCopied").style.display = "block";
      document.execCommand("copy");
      setTimeout(function () {
        document.getElementById("RTMPURLCopied").style.display = "none";
      }, 1000);
    },
  },
  computed: {
    getPublishLink() {
      var customDomain = vm.$store.state.customDomain;
      var eventId = vm.getEventId();
      return "https://" + customDomain + "/event/" + eventId;
    },
  },
};
</script>